import Authorize from './Authorize';

export default Authorize;
